import { useState } from "react";
import { Link } from "react-router-dom";
import { Checkbox } from "./ui/checkbox";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { saveAck } from "../lib/gate";
import { Watermark } from "./Botanical";

export default function ResearcherGate({ onAccept }) {
  const [institution, setInstitution] = useState("");
  const [b1, setB1] = useState(false);
  const [b2, setB2] = useState(false);
  const [b3, setB3] = useState(false);
  const canProceed = b1 && b2 && b3;

  const handleAccept = () => {
    if (!canProceed) return;
    saveAck({ institution });
    onAccept?.();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[#59394F]/40 backdrop-blur-md p-4" data-testid="researcher-gate" role="dialog" aria-modal="true" aria-label="Research Use Only confirmation">
      <div className="w-full max-w-xl bg-[#F4EBDD] rounded-3xl shadow-[0_24px_80px_rgba(45,45,45,0.18)] border border-[#A8B59A]/30 overflow-hidden">
        <div className="px-8 pt-10 pb-6 border-b border-[#A8B59A]/20 relative overflow-hidden">
          <Watermark opacity={0.45} height="h-[200px]" testid="gate-watermark" />
          <p className="relative text-xs uppercase tracking-[0.3em] text-[#5E6B51] font-medium mb-3">Research Use Only</p>
          <h2 className="relative font-serif text-3xl sm:text-4xl text-[#5A433B] leading-tight">A quick note before you browse</h2>
          <p className="relative mt-3 text-sm text-[#5E4D5A] leading-relaxed max-w-md">
            Our catalog is intended for qualified research professionals only. Please confirm the following to continue.
          </p>
        </div>

        <div className="px-8 py-6 space-y-5">
          <label className="flex gap-3 items-start cursor-pointer group">
            <Checkbox data-testid="gate-check-researcher" checked={b1} onCheckedChange={(v) => setB1(!!v)} className="mt-1" />
            <span className="text-[15px] text-[#5A433B] leading-snug">I am a qualified researcher.</span>
          </label>

          <div>
            <Label htmlFor="institution" className="text-xs uppercase tracking-[0.2em] text-[#5E4D5A]">Institution or Organization (optional)</Label>
            <Input id="institution" data-testid="gate-institution" value={institution} onChange={(e) => setInstitution(e.target.value)} className="mt-2 rounded-xl border-[#A8B59A]/40" placeholder="e.g., University Lab, Research Co." />
          </div>

          <label className="flex gap-3 items-start cursor-pointer">
            <Checkbox data-testid="gate-check-age" checked={b2} onCheckedChange={(v) => setB2(!!v)} className="mt-1" />
            <span className="text-[15px] text-[#5A433B] leading-snug">I am 21 years of age or older.</span>
          </label>

          <label className="flex gap-3 items-start cursor-pointer">
            <Checkbox data-testid="gate-check-policy" checked={b3} onCheckedChange={(v) => setB3(!!v)} className="mt-1" />
            <span className="text-[15px] text-[#5A433B] leading-snug">
              I have read and agree to the{" "}
              <Link to="/policies/ruo" className="underline decoration-[#C99898] decoration-2 underline-offset-4 hover:text-[#59394F] transition-colors" target="_blank" data-testid="gate-policy-link">
                Research Use Only Policy
              </Link>.
            </span>
          </label>
        </div>

        <div className="px-8 py-6 bg-white/60 border-t border-[#A8B59A]/20 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <p className="text-xs text-[#5E4D5A] leading-snug max-w-xs">
            Checking these does not establish verified research credentials. Buyer verification happens separately before any regulated purchase.
          </p>
          <Button
            onClick={handleAccept}
            disabled={!canProceed}
            data-testid="gate-accept-btn"
            className="rounded-full bg-[#59394F] hover:bg-[#432A3B] text-white px-8 py-6 h-auto text-base transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Enter the catalog
          </Button>
        </div>
      </div>
    </div>
  );
}
